module.exports = __webpack_public_path__ + "adfd9e35e4b1aa179bd53e48c00e49fc.fbx";